interface GtagItems {
  items: {
    id: number;
    title?: string;
    price?: number;
    quantity?: number;
  }[];
}

document.addEventListener("DOMContentLoaded", async () => {
  await handleRemoveFromCart();
  await handleVisitCart();
  await handleAddToCartSimple();
  await handleSetCheckoutOption();
  await handlePurchase();
});

const handleRemoveFromCart = async () => {
  const page_data = window.page_data;

  if (page_data.is_cart != true) {
    return;
  }

  window.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;

    if (target.classList.contains("remove") && target.classList.contains("actions__button")) {
      const product_id = target.getAttribute("data-product_id") as string;

      if (!product_id) return;

      const wrapper = target.closest(".cart-item") as HTMLElement;
      const title = wrapper.querySelector(".title__text")?.textContent as string;
      const price = wrapper.querySelector(".woocommerce-Price-amount bdi")?.textContent as string;

      const gtagData: GtagItems = {
        items: [
          {
            id: parseInt(product_id),
            title: title,
            price: parseInt(price),
          },
        ],
      };

      gtag("event", "remove_from_cart", gtagData);
      console.log("remove_from_cart", gtagData);
    }
  });
};

const handleVisitCart = async () => {
  const page_data = window.page_data;

  if (page_data.is_cart != true) {
    return;
  }

  const cart_wrapper = document.querySelector(".cart-container") as HTMLElement;
  const cart_items = cart_wrapper.querySelectorAll(".cart-item") as NodeListOf<HTMLElement>;

  if (cart_items.length == 0) {
    return;
  }

  const gtagData: GtagItems = {
    items: [],
  };

  cart_items.forEach((item) => {
    const product_id = item.querySelector(".remove")?.getAttribute("data-product_id") as string;
    const title = item.querySelector(".title__text")?.textContent as string;
    const price = item.querySelector(".woocommerce-Price-amount bdi")?.textContent as string;

    gtagData.items.push({
      id: parseInt(product_id),
      title: title,
      price: parseInt(price),
    });
  });

  gtag("event", "view_cart", gtagData);
  console.log("view_cart", gtagData);
};

const handleAddToCartSimple = async () => {
  const add_to_cart_buttons = document.querySelectorAll(".add_to_cart_button") as NodeListOf<HTMLElement>;

  if (add_to_cart_buttons.length == 0 && window.page_data.is_product != true) {
    return;
  }

  add_to_cart_buttons.forEach((button) => {
    button.addEventListener("click", () => {
      const product_id = button.getAttribute("data-product_id") as string;
      if (!product_id) return;

      const wrapper = button.closest(".product-wrapper") as HTMLElement;
      if (!wrapper) return;

      const title = wrapper.querySelector("[gtag-product-title]")?.textContent as string;
      const price = wrapper.querySelector(".woocommerce-Price-amount bdi")?.textContent as string;

      const gtagData: GtagItems = {
        items: [
          {
            id: parseInt(product_id),
            title: title,
            price: parseInt(price),
            quantity: 1,
          },
        ],
      };

      gtag("event", "add_to_cart", gtagData);
      console.log("add_to_cart", gtagData);
    });
  });
};

interface GtagCheckoutOptionEvent {
  checkout_option: string;
  value: string;
  label?: string;
  price?: Number;
}

const handleSetCheckoutOption = async () => {
  const page_data = window.page_data;

  if (page_data.is_checkout != true) {
    return;
  }

  document.addEventListener("change", (e) => {
    let gtagData: GtagCheckoutOptionEvent;
    const target = e.target as HTMLInputElement;

    if (target.classList.contains("shipping_method")) {
      const label = target.nextSibling as HTMLElement;
      const price = label?.querySelector(".woocommerce-Price-amount bdi")?.textContent as string;

      gtagData = {
        checkout_option: "shipping_method",
        value: target.value,
        label: label.textContent as string,
        price: price ? parseFloat(price.replace(",", ".")) : 0,
      };
    } else if (target.name === "payment_method") {
      const label = document.querySelector(`label[for="${target.id}"]`) as HTMLElement;
      const clean_label = label.textContent ? label.textContent.replace(/(\r\n|\n|\r)/gm, "").trim() : ("" as string);

      gtagData = {
        checkout_option: "payment_method",
        value: target.value,
        label: clean_label,
      };
    } else {
      return false;
    }

    gtag("event", "set_checkout_option", gtagData);
    console.log("set_checkout_option", gtagData);
  });
};

interface GtagOrderData {
  transaction_id: string;
  affiliation?: string;
  value?: number;
  currency?: string;
  tax?: number;
  shipping?: number;
  items?: {
    id: number;
    title?: string;
    price?: number;
    quantity?: number;
  }[];
}

const handlePurchase = async () => {
  const page_data = window.page_data;
  const order = window.order_data;

  if (page_data.is_thankyou != true || !order) {
    return;
  }

  const order_details: GtagOrderData = {
    transaction_id: order.transaction_id,
    affiliation: order.affiliation,
    value: order.value,
    currency: order.currency,
    tax: order.tax,
    shipping: order.shipping,
    items: order.items,
  };

  gtag("event", "purchase", order_details);
  console.log("purchase", order_details);
};
